<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_ProductMeasureunit_Management']">
		<template #badges>
			<nk-badge system="sale"></nk-badge>
		</template>
		<nk-table v-model="selectedRow" @data-changed="dataChanged" :data="measureUnits" :options="tableOptions" ref="table" tabindex="101" startup class="nk-card">
		</nk-table>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import Dropdown from '@/components/general/dropdown.vue'
	import $sc from '~/plugins/shortcut.collection'
	import { post } from '~/plugins/nikan-api'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import Endpoints from '@nikan/endpoints'
	import validators from '~/statics/validators'
	import emptyId from '~/statics/empty-id'
	import { mapActions, mapGetters } from 'vuex'

	export default {
		modal: {
			size: 'md',
			stateUID: 'measure-units',
			helpTag: 'MeasureUnitList'
		},
		props: {
			data: { type: [Array, Object] },
			options: { type: Object },
		},
		data() {
			return {
				localSelectedItem: null,
				selectedRow: null,
				moadianUnits: [],
				tableOptions: {
					activeRowDisabled: false,
					editable: this.$nikan.checkPermission('Product_ProductMeasureunit_Edit'),
					alwaysEmit: true,
					searchable: false,
					buttons: {
						addBtn: {
							options: {
								visible: true,
								policyClaims: 'Product_ProductMeasureunit_Edit',
							}
						},
						deleteBtn: {
							options: {
								visible: true,
								policyClaims: 'Product_ProductMeasureunit_Edit',
							}
						}
					},
					allowNewRow: true,
					prepareNewRow: () => {
						let moadianCode = ''
						if (this.moadianUnits.length)
							moadianCode = '1687'
						return {
							companyId: emptyId,
							name: '',
							moadianCode: moadianCode
						}
					},
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							entering: false,
							pinned: true,
							pinnable: false,
							resizable: false,
							width: '10%',
						},
						{
							name: 'code',
							title: this.$t('code'),
							searchable: true,
							sortable: true,
							editable: false,
							entering: false,
							pinned: false,
							pinnable: true,
							resizable: false,
							width: '70px',
						},
						{
							name: 'name',
							title: this.$t('sale.measure-unit.f.name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '90%',
						},
						{
							name: 'moadianCode',
							title: this.$t('sale.measure-unit.f.moadianName'),
							edit: (row) => {
								return {
									component: Dropdown,
									options: {
										data: this.moadianUnits,
										targetField: 'code',
										getDataFromOptions: true,
										locateSelectorBasedOnDocument: true,
										searchableFields: ['name'],
										display: (item) => {
											return item.name
										},
									}
								}
							},
							view: {
								options: {
									format: (item) => {
										const found = this.moadianUnits.find(x => x.code === item)
										return found && found.name
									}
								}
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '90%',
						},
					],
				},
				pageButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						isPrimary: true,
						icon: 'save',
						visible: true,
						disabled: true,
						handle: (button, page, e) => {
							this.save().then((res) => {
								this.$nikan.formUtility.switchMode(this.pageButtons, 'select')
								this.$refs.table.table_Focused()
							})
						},
					},
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('select'),
						icon: 'check',
						visible: (this.options || {}).selectable,
						disabled: false,
						isPrimary: true,
						handle: (button, page, e) => {
							this.resolve(this.selectedRow)
						},
					},
				}
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},
		computed: {
			...mapGetters({
				all: 'productMeasureUnits/all'
			}),
			measureUnits() {
				return this.all
			}
		},
		created() {
			this.selectedRow = this.data
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			let buttonsArray
			if (this.grandParentType() === 'modal') {
				buttonsArray = [this.pageButtons.selectButton, this.pageButtons.saveButton]
			} else {
				this.pageButtons.selectButton.visible = false
				buttonsArray = [this.pageButtons.saveButton]
			}

			this.prepareWindow(this.$t('sale.measure-unit.list-title'), buttonsArray)

			this.prepareData()
		},
		methods: {
			...mapActions({
				refreshProductMeasureUnits: 'productMeasureUnits/refresh',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			prepareData() {
				this.refreshProductMeasureUnits()
				post(Endpoints.getUrl('measureunit.moadianUnitList'))
					.then((result) => {
						this.moadianUnits = result.data.items
					})
					.catch(() => {
						this.defer(() => this.$refs.table.$el.focus(), 1)
					})
			},
			dataChanged() {
				this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
			},
			save() {
				return new Promise((resolve, reject) => {
					this.$refs.table
						.commitChanges()
						.then((measureunits) => {
							post(Endpoints.getUrl('measureunit.modify'), {
								items: measureunits,
							})
								.then((result) => {
									this.broadcastRefresh('ProductMeasureUnits')
									resolve(this.measureUnits)
									this.$toast(this.$t('sale.measure-unit.save-success'), { type: 'success' })
									this.defer(() => {
										this.$refs.table.$el.focus()
									}, 1000)

								})
								.catch(() => {
									this.defer(() => this.$refs.table.$el.focus(), 1)
								})
						})
						.catch((errorRows) => {
							if (Array.isArray(errorRows)) {
								var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
								dialog({
									title: this.$t('sale.warehouse.m.save-warehouse-title'),
									body: this.$t('sale.measure-unit.save-error-rows', {
										rowNumbers,
									}),
									type: 'error',
								})
							} else {
								dialog({
									title: this.$t('sale.warehouse.m.save-warehouse-title'),
									body: errorRows.message,
									type: 'error',
								})
							}

							reject(new Error('invalid-rows'))
							this.defer(() => this.$refs.table.$el.focus(), 100)
						})
				})
			},
		},
	}
</script>
<style></style>
